import 'jquery';
import 'bootstrap';
import 'js-cookie';
import 'slick-carousel';

import './cookie-approval';


import '../sass/main.sass';

function requireAll(r) {
    r.keys().forEach(r);
}

requireAll(require.context('../../src/templates/', true, /\.ss$/));
requireAll(require.context('../../src/img/', true, /\.(gif|png|jpe?g|svg)$/));
requireAll(require.context('../../src/fonts/', true, /\.(eot|svg|ttf|woff|woff2|otf)$/));


/*
 * REAL CODE FROM HERE!
 */

/**
 * TODO: GA-Event einbauen "Bis zum Ende gescrolled"
 * TODO: GA-Event einbauen "Telefonnummer geklickt"
 * TODO: GA-Event einbauen "Kontaktformular benutzt"
 * TODO: GA-Event einbauen "E-Mail Adresse angeklickt"
 * TODO: GA-Event einbauen "Produkt-Frage-Formular benutzt"
 * TODO: GA-Event einbauen "Zum Newsletter angemeldet"
 * TODO: GA-Event einbauen "Länger als 3 Minuten auf Unterseite"
 */


$(document).ready(function () {

    /**
     * Prüfe ob Formulare da sind?
     * Falls ja schaue nach ob Messages existieren die gezeigt werdeb müssen.
     * Falls ja, öffne das umliegende Collapse und scrolle zum Formular
     */
    var formMessages = $('form .message');
    var openAndScroll = false;
    if (formMessages.length > 0){
        $.each(formMessages, function(){
            if($.trim($(this).html()) !== ''){
                openAndScroll = true;
                return false;
            }
        });

        if (openAndScroll){
            var parentCollapse = formMessages.first().closest('.collapse');

            if (parentCollapse.length > 0){
                parentCollapse.collapse('show');
            }

            setTimeout(function () {
                $('html, body').animate({
                    scrollTop:  formMessages.first().closest('form').offset().top - 150
                }, 250, 'swing');
            },250);
        }
    }


    var hash = location.hash;
    var target = $(hash);

    if (target.length > 0) {
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: $(hash).position().top
            }, 1000, 'swing', function () {
                // Add hash (#) to URL when done scrolling (default click behavior)
                window.location.hash = hash;
            });
        }, 100);
    }



});

$('#main-nav').on('show.bs.collapse', function () {
    $(this).parent().find('.hamburger').addClass('is-active');
});

$('#main-nav').on('hide.bs.collapse', function () {
    $(this).parent().find('.hamburger').removeClass('is-active');
});

function disableButton(e) {
    var oneClickerButton = $(this).find('.one-clicker');
    oneClickerButton.attr('disabled', true);
    oneClickerButton.val('Bitte warten');
    return true;
}

$('form').on('submit', disableButton);


$("#facebook-share").on("click",function(){
    var link = $(this).data('shareurl');
    var fbpopup = window.open("https://www.facebook.com/sharer/sharer.php?u="+link+"", "pop", "width=600, height=400, scrollbars=no");
    return false;
});

$('.product-images-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    rows: 0,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [

        {
            breakpoint: 576,
            settings: {
                arrows: false,
            }
        }
    ]
});

$('.content-images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    rows: 0,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [

        {
            breakpoint: 576,
            settings: {
                arrows: false,
            }
        }
    ]
});

var inputs = document.querySelectorAll( 'input.frontendfile' );

$.each(inputs, function(){
    var label = $(this).closest('.field.frontendfile').find('label');
    var labelVal = label.html();
    $(this).on('change', function( e ) {
        var fileName = '';
        if( this.files && this.files.length > 1 )
            fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
        else
            fileName = e.target.value.split( '\\' ).pop();

        if( fileName )
            label.html(fileName);
        else
            label.html(labelVal);
    });

});


var mapObjects = [];
window.initMap = function () {
    var mapContainers = $('.map-container');
    $.each(mapContainers, function (item) {
        var mapContainer = $(this);
        var mapSpecs = mapContainer.data('mapspecs');
        var mapObject = new google.maps.Map(mapContainer[0], mapSpecs);

        var marker = new google.maps.Marker({
            position: {
                lat: mapSpecs.center.lat,
                lng: mapSpecs.center.lng,
            },
            draggable: false,
            animation: google.maps.Animation.DROP,
        });

        marker.setMap(mapObject);
        mapObjects.push(mapObject);
    });
};

// Add smooth scrolling to all links
$("a").on('click', function (event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();
        // Store hash
        var hash = this.hash;
        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
            scrollTop: $(hash).offset().top
        }, 1000, 'swing', function () {
            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
        });
    } // End if
});

$(document).on('scroll resize', function () {
    var viewportHeight = $(window).height();
    var scrolled = $(document).scrollTop() > viewportHeight / 2;
    var toTopButton = $('#to-top');

    if (scrolled) {
        if (!toTopButton.hasClass('active')) {
            toTopButton.addClass('active');
        }
    } else {
        toTopButton.removeClass('active');
    }

});





// WEBPACK FOOTER //
// ./src/js/app.js